// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ZaN4"};